<template>
	<ul class="list">
		<li
			v-for="(item, idx) in this.$store.state.modal.params"
			:key="idx"
			class="list__item"
		>
			<div class="list__item__card card">
				<router-link
					v-if="item.href"
					class="card__link"
					:to="item.href"
					target="_blank"
					>{{ item.title }}</router-link
				>
				<div v-else class="card__review">
					<p class="card__review__title">{{ item.title }}</p>
					<template v-if="item.subTitles">
						<p
							v-for="(subTitle, subTitleIdx) in item.subTitles"
							:key="subTitleIdx"
							v-html="subTitle"
							class="card__review__sub-title"
						/>
					</template>
					<p
						v-if="item.text"
						:class="[
							'card__review__contents',
							{
								'card__review__contents--red': item.isBlind,
							},
						]"
					>
						{{ item.text }}
					</p>
				</div>
			</div>
		</li>
	</ul>
</template>
<script>
	export default {
		name: 'RegisterSimpleList',
	};
</script>
<style lang="scss" scoped>
	.list__item {
		margin-top: 8px;

		&:first-child {
			margin-top: 0;
		}
	}

	.card {
		background: white;
		border-radius: 4px;
		box-shadow:
			0px 1px 3px 0px rgba(0, 0, 0, 0.2),
			0px 1px 1px 0px rgba(0, 0, 0, 0.14),
			0px 2px 1px -1px rgba(0, 0, 0, 0.12);
	}

	.card__link,
	.card__review {
		display: block;
		width: 100%;
		padding: 5px 8px;

		&:hover {
			background: #f4f7fa;
		}
	}

	.card__link,
	.card__review__title {
		line-height: 20px;
		font-size: 1rem;
		font-weight: 700;
	}

	.card__link {
		cursor: pointer;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		text-align: left;

		&:hover {
			color: $btn-blue;
			text-decoration: underline;
		}
	}

	.card__review__sub-title,
	.card__review__contents {
		line-height: 14px;
	}

	.card__review__contents {
		margin-top: 8px;
		padding-top: 8px;
		border-top: solid 1px #dfe6ee;
	}

	.card__review__contents--red {
		color: $red;
	}
</style>
